import React, { Component } from 'react';
import mainLogo from './../assets/mainLogo.png';
import { Link } from 'react-router-dom';


class Logo extends Component {
    render() {
        
        return (
            <div className="logoContainer">
                <Link to='/'><img src={mainLogo} id="mainLogo" className="mainLogo" width="40" alt="logo" /></Link>
            </div>
        );
    }
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo.js